module.exports = __webpack_public_path__ + "1.5.0-unryo/img/online-portal-2.51956152.svg";